import {Link, withRouter} from 'react-router-dom'
import * as React from 'react'
import styled from 'styled-components'

import { Content } from '../../atoms/Content/index'
import { Layout } from '../../atoms/Layout'
import { Nav } from '../../atoms/Nav'
import { ProfileDropdown } from '../../organisms/ProfileDropdown'
import Box, { Row } from '../../atoms/Box'
import Image from '../../atoms/Image'
import MenuStore from "../../stores/MenuStore";
import MobileMenu from "../../atoms/MobileMenu";
import {KidsPageCheck} from "../../atoms/KidsPageCheck";
import {Query} from '@apollo/client/react/components'
import {GET_OWN_INTAKE_QUERY} from "../../queries/GET_OWN_INTAKE_QUERY";
import {intakeMetrics} from "../../organisms/Intakes/intakeMetrics/calcIntakeMetrics";

const lang = process.env.REACT_APP_LANGUAGE === 'es' ? 'es' : 'en'


const translations = {
  'en': {
    activities: 'Activities',
    buildGame: 'Juego de Construir un Cuarto',
    games: 'Games',
    maskGame: 'Mask Game',
    selectGame: 'Select Game',
    sleepRoomGame: 'Sleep Room Game',
    tour: 'Tour',
    video: 'Video',
    wakeUpRoomGame: 'Wake up room game'
  },
  'es': {
    activities: 'Actividades',
    buildGame: 'Juego de Construir un Cuarto',
    games: 'Juegos',
    maskGame: 'Juego de Mascarilla',
    selectGame: 'Seleccione un juego',
    sleepRoomGame: 'Juego del Cuarto de Dormir',
    tour: 'Recorrido',
    video: 'Video',
    wakeUpRoomGame: 'Juego del Cuarto de Despertar'
  },
}

// tslint:disable:max-line-length object-literal-sort-keys
const HomeImage = styled.img`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
`

const Title= styled.h1`
  text-align: center;
  font-family: Nunito;
  font-weight: 900;
  font-size: 2rem !important;
  color: #043E74;
`

const TextContainer = styled.div`
    padding-left: 20px;
    position: relative;
    background: #C7F0F6;
    min-height: 500px;
    top: 20px;
    border-radius: 10px;
    padding-top: 30px;
    z-index: 1;
    box-shadow: 0 8px 40px 0 rgba(194, 111, 35, 0.2), 0 16px 80px 0 rgba(194, 111, 35, 0.2);
`

const GameName = styled.div`
  color: #2F358A;
  font-family: Nunito;
  font-size: 1.4rem;
  font-weight: 600;
  text-align: center;
  line-height: 1.5rem;
`

const GameBox = styled(Box)`
  align-items: center;
  min-width: 215px;
  flex: 1;
  padding-bottom: 36px;
  text-align:center;

  @media (max-width: 600px) {
    min-width: 137px;
  }
`

const GameImage = styled(Image)`
  width: 210px;
  height: 215px;

  @media (max-width: 600px) {
    width: 137px;
    height: 140px;
  }

`


class GamesPage extends React.Component {
  menuStore

  constructor (props) {
    super(props)
    this.menuStore = MenuStore.create({})
  }

  render() {
    return (
      <Layout hasKidBackground>
        <Nav.KidsBar>
          <Nav.KidsSite
            onClick={() => {
              this.menuStore.showMenu()
            }}
          />
          <Nav.KidsButton link="/kids-video" name="navBarVideo" text={`${translations[lang].video}`} />
          <Nav.KidsButton link="/kids-tour" name="navBarTourActive" text={`${translations[lang].tour}`} />
          <Nav.KidsButton link="/kids-games" name="navBarGames" active text={`${translations[lang].games}`} />
          <Nav.KidsButton link="/kids-activities" name="navBarActivities" text={`${translations[lang].activities}`} />
          <ProfileDropdown color="#CEE3F9"/>
        </Nav.KidsBar>
        <MobileMenu store={this.menuStore} />
        <Content>
          <div style={{position: 'relative'}}>
            <TextContainer>
              <div style={{position: 'relative', zIndex: 10}}>
                <Title>{translations[lang].selectGame}</Title>
                <Box style={{height: '1rem'}} />
                <Row style={{flexWrap: 'wrap'}}>
                  <GameBox>
                    <Link to="/kids-mask-game">
                      <GameImage name="gameMask"  />
                      <GameName>{translations[lang].maskGame}</GameName>
                    </Link>
                  </GameBox>
                  <GameBox>
                    <Link to="/kids-sleep-game">
                      <GameImage name="gameSleep" />
                      <GameName>{translations[lang].sleepRoomGame}</GameName>
                    </Link>
                  </GameBox>
                  <GameBox>
                    <Link to="/kids-wake-game">
                      <GameImage name="gameWake" />
                      <GameName>{translations[lang].wakeUpRoomGame}</GameName>
                    </Link>
                  </GameBox>
                  {window.localStorage.getItem('userType') === 'PARENT_WEBTIPS_ES_EXTENSION' && (
                    <GameBox>
                      <Link to="/kids-build-game">
                        <GameImage name="gameBuild" />
                        <GameName>{translations[lang].buildGame}</GameName>
                      </Link>
                    </GameBox>
                  )}
                </Row>
              </div>
              <HomeImage
                id="image"
                src="https://s3-us-west-1.amazonaws.com/uci-images/images/kidsEmptyBackground.svg"
                alt=""/>
              <Box h={20} />
            </TextContainer>

          </div>
          <Box h={20} />
        </Content>

      </Layout>
    )
  }
}

const KidsGamesPage = withRouter(
  class Page extends React.Component {
    render () {
      return (
        <Query query={GET_OWN_INTAKE_QUERY}>{({ data, loading, error }) => {
          if (loading) { return null }
          if (error || !data || !data.getOwnIntake) { window.location.reload() }
          const intake = data.getOwnIntake
          const {
            section4ReviewCompleted
          } = intakeMetrics(intake)

          if (!section4ReviewCompleted) {
            this.props.history.replace('/kids-forbidden')
            return <div />
          }

          return (
            <GamesPage />
          )
        }}
        </Query>
      )
    }
  }
)

export {KidsGamesPage}



// WEBPACK FOOTER //
// ./src/pages/KidsGamesPage/index.js